@if (timePickerForm) {
  <form [formGroup]="timePickerForm">
    <div class="timePickerWrapper">
      <div class="time-input-controls" [class.disabled]="disabled">
        <button type="button" class="btn" (click)="subTime()" [disabled]="time <= 0 || disabled" tabindex="-1"><svg-icon key="arrow-button-left" fontSize="11px" /></button>
        <div id="time_input">
          <input type="text" name="hour" formControlName="hour" maxlength="2" (input)="onInput($event, 'hour')" (focus)="selectInput($event)" (blur)="onBlur($event, 'hour')" />
          :
          <input type="text" name="minute" formControlName="minute" maxlength="2" (input)="onInput($event, 'minute')" (focus)="selectInput($event)" (blur)="onBlur($event, 'minute')" />
        </div>
        <button type="button" class="btn" (click)="addTime()" [disabled]="time >= maxDayTime || disabled" tabindex="-1">
          <svg-icon key="arrow-button-right" fontSize="11px" />
        </button>
      </div>

      @if (f.dayTimePeriod?.enabled) {
        <div #amPmToggle class="am-pm-toggle" (keydown.space)="$event.preventDefault()" (keyup.space)="toggleAmPm()" [class.disabled]="disabled" tabindex="0">
          <input type="radio" formControlName="dayTimePeriod" value="AM" />
          <label class="am-item" [class.selected]="f.dayTimePeriod?.value === 'AM'" (click)="toggleAmPm()">AM</label>
          <input type="radio" formControlName="dayTimePeriod" value="PM" />
          <label class="pm-item" [class.selected]="f.dayTimePeriod?.value === 'PM'" (click)="toggleAmPm()">PM</label>
        </div>
      }
    </div>
    @if (!disabled && timePickerForm.touched && (timePickerForm.errors?.hourRequired || timePickerForm.errors?.minuteRequired)) {
      <mat-error>Time is required</mat-error>
    }
  </form>
}
